import React from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

const iconFallbackMap = {
  "simple-icons:express": "fas fa-server",
  "simple-icons:mongodb": "fas fa-database",
  "simple-icons:mysql": "fas fa-database",
  "simple-icons:postgresql": "fas fa-database",
  "simple-icons:socketdotio": "fas fa-broadcast-tower",
  "simple-icons:postman": "fas fa-paper-plane",
  "simple-icons:jsonwebtokens": "fas fa-user-shield"
};

export default function SoftwareSkill() {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {skillsSection.softwareSkills.map((skills, i) => {
            const iconClass =
              iconFallbackMap[skills.fontAwesomeClassname] ||
              skills.fontAwesomeClassname;
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i className={iconClass}></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
